import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);
import permissionsCheck from "./permissions-check/permissionsCheck";
import moduleAuth from "./auth/moduleAuth.js";
import moduleECommerce from "./eCommerce/moduleECommerce.js";
import firebaseAuth from "./firebase/firebaseAuth";
import firebaseRealtime from "./firebase/firebaseRealtimeDB";
import firebaseStorage from "./firebase/firebaseStorage";
import moduleNotification from "./notification/moduleNotification";
import moduleRoutingType from "./routing-type/moduleRoutingType";
import moduleVisitPoint from "./visit-point/moduleVisitPoint";
import moduleSetting from "./setting/moduleSetting";
import moduleCompanyConfig from "./company-config/moduleCompanyConfig";
import modulePreferences from "./preferences/modulePreferences";
import moduleMatchFilter from "./match-filter/moduleMatchFilter";
import uploadFile from "./upload-file/uploadFile";
import optimizerManager from "./optimizer-manager/moduleOptimizerManager";
import vehicle from "./vehicle/moduleVehicle";
import frequency from "./frequency/moduleFrequency";

export default new Vuex.Store({
	getters,
	mutations,
	state,
	actions,
	modules: {
		auth: moduleAuth,
		eCommerce: moduleECommerce,
		firebaseAuth,
		firebaseRealtime,
		firebaseStorage,
		permissionsCheck,
		moduleNotification,
		moduleRoutingType,
		moduleVisitPoint,
		moduleSetting,
		moduleCompanyConfig,
		modulePreferences,
		uploadFile,
		moduleMatchFilter,
		optimizerManager,
		vehicle,
		frequency,
	},
	strict: false,
});
